import { Role } from "./enums/role.enum";
import { UserInterface } from "./interfaces/user.interface";

export class User {
  id = null;
  first_name = "";
  last_name = "";
  full_name = "";
  email = "";
  role = Role.Employee;

  static create(data?: UserInterface): User {
    return new User(data);
  }

  constructor(args: UserInterface = {}) {
    Object.assign(this, args);
  }
}



// WEBPACK FOOTER //
// ./src/models/user.model.ts